// extracted by mini-css-extract-plugin
export default {"container":"MobilePlayer_container__trYGI","content":"MobilePlayer_content__P7k+c"};